import { axiosAuthed } from './setCommonHeaders';

// POST /saved-workouts/transfer only starts the transfer; completion is only
// observable by polling GET /saved-workouts/transfer/:id until `finished`.
const POLL_INTERVAL_MS = 1500;
// Stop actively waiting after ~90s — callers treat that as "still importing",
// not a failure (the server keeps running regardless).
const MAX_POLLS = 60;
const MAX_POLL_FAILURES = 3; // tolerate transient status-read blips

const delay = (ms) => new Promise((resolve) => { setTimeout(resolve, ms); });

// Resolves with the final status payload, { timedOut: true }, or { cancelled: true };
// rejects only after MAX_POLL_FAILURES consecutive status-read failures.
const pollTransferStatus = (transferId, isCancelled = () => false, attempt = 0, failures = 0) => {
  if (isCancelled()) return Promise.resolve({ cancelled: true });
  if (attempt >= MAX_POLLS) return Promise.resolve({ timedOut: true });
  return axiosAuthed.get(`/saved-workouts/transfer/${transferId}`)
    .then((response) => {
      if (response.data.finished) return response.data;
      return delay(POLL_INTERVAL_MS)
        .then(() => pollTransferStatus(transferId, isCancelled, attempt + 1, 0));
    })
    .catch((err) => {
      if (failures + 1 >= MAX_POLL_FAILURES) throw err;
      return delay(POLL_INTERVAL_MS)
        .then(() => pollTransferStatus(transferId, isCancelled, attempt + 1, failures + 1));
    });
};

export default pollTransferStatus;
